import * as React from 'react';
import { useOutlet } from 'react-router-dom';
import { NotFound } from '../Layout/NotFound';
import { useAppSelector } from '../../Store/store';
import { tokenSelector } from '../../Store/authSlice';

export const ProtectedRoute = () => {
  const outlet = useOutlet();

  const token = useAppSelector(tokenSelector);

  if (!token) {
    return <NotFound />;
  }

  return <>{outlet}</>;
};
